module.exports = __webpack_public_path__ + "img/120-55-plan.33c50d37.jpg";